import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AppContextSwitcherPopup from "./AppContextSwitcherPopup";

// styles
require("./TopBarWithBreadCrumb.css");

interface Props {
  contextLevel: string;
  pageLevel: string;
  showBreadCrumb?: boolean;
  rightAreaComponent?: JSX.Element | undefined;
}

const TopBarWithBreadCrumb = (props: Props) => {
  const { t } = useTranslation();
  const [contextPopupVisible, setContextPopupVisible] = useState(false);
  const appInfo = useSelector((state: any) => state.appInfo);

  return (
    <>
      {contextPopupVisible && (
        <AppContextSwitcherPopup
          handleCancellation={() => {
            setContextPopupVisible(false);
          }}
        />
      )}
      <nav aria-label="breadcrumb row">
        <div className="navigationContainer">
          <div className=" col-8">
            {!!props.showBreadCrumb && (
              <ol className="breadcrumb" style={{ alignItems: "center" }}>
                <li className="breadcrumb-item">
                  <a
                    style={{ color: "blue", textDecoration: "underline" }}
                    onClick={() => {
                      setContextPopupVisible(true);
                    }}
                    href="#"
                  >
                    {appInfo.Context}
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {props.pageLevel}
                </li>
              </ol>
            )}
          </div>
          {props.rightAreaComponent && (
            <div className="rightAreaComponent col-4">
              {props.rightAreaComponent}
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default TopBarWithBreadCrumb;
